<template lang="pug">
  .b-crm-lead-detail-comment
    //- непрочитанное уведомление о комментарии (crm-lead-comment-publish приходит с info.commentId).
    //- leadId в запросе обязателен: id комментариев заявок и задач — разные
    //- последовательности, по одному commentId можно сбросить чужое уведомление
    NotificationCountSingle._notification-count(:query="{ commentId: comment.id, leadId }")
    UserAvatar._avatar(:user="comment.author" :size="32")
    ._body
      ._top
        span._author {{ authorName }}
        span._date {{ date }}
        EllipsisMenu._menu(v-if="menuItems.length" :items="menuItems" light)
      template(v-if="editing")
        textarea._edit(ref="edit" v-model="draft" rows="2")
        ._edit-buttons
          Btn(xs blue type="button" :disabled="!draft.trim()" @click="save") Сохранить
          Btn(xs grey type="button" @click="cancel") Отмена
      p._text(v-else) {{ text }}
      ._attachments(v-if="files.length")
        FileList(:files="files")
</template>

<script>
import utils from '@/utils/common';

import UserAvatar from '@/components/UserAvatar.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import FileList from '@/components/FileList.vue';
import NotificationCountSingle from '@/components/base/NotificationCountSingle.vue';

export default {
  name: 'CrmLeadDetailComment',
  components: { UserAvatar, EllipsisMenu, FileList, NotificationCountSingle },
  props: {
    // запись ленты типа comment
    comment: {
      type: Object,
      required: true,
    },
    // заявка, к которой относится комментарий — для поиска уведомления
    leadId: {
      type: Number,
      required: true,
    },
    // редактировать и удалять свой комментарий может автор; владелец и
    // заместитель компании удаляют любой — решение принимает родитель
    editable: Boolean,
    removable: Boolean,
  },
  data() {
    return {
      editing: false,
      draft: '',
    };
  },
  computed: {
    authorName() { return this.comment.author ? utils.getUserName(this.comment.author) : ''; },
    date() { return utils.convertDateToString(this.comment.createdAt, 'numeric', true); },
    // текст комментария сервер отдаёт внутри info, поля text на чтение нет
    text() { return this.comment.info?.text ?? ''; },
    files() {
      return (this.comment.files ?? []).map(file => ({ id: file.id, file }));
    },
    menuItems() {
      const items = [];

      if (this.editable) {
        items.push({ text: 'Изменить', icon: 'edit2', handler: this.startEdit });
      }
      if (this.removable) {
        items.push({ text: 'Удалить', icon: 'trash', handler: () => this.$emit('remove', this.comment) });
      }

      return items;
    },
  },
  methods: {
    startEdit() {
      this.draft = this.text;
      this.editing = true;
      this.$nextTick(() => this.$refs.edit?.focus());
    },
    cancel() {
      this.editing = false;
      this.draft = '';
    },
    save() {
      const text = this.draft.trim();
      if (!text) return;

      this.editing = false;
      this.$emit('edit', { comment: this.comment, text });
    },
  },
};
</script>

<style scoped lang="scss">
.crm-lead-detail-comment {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;

  // кружок в правом верхнем углу аватара, как у комментариев задач (CommentTile)
  &__notification-count {
    position: absolute;
    top: -6px;
    left: 22px;
    z-index: 1;
  }

  &__avatar {
    flex-shrink: 0;
  }

  &__body {
    flex-grow: 1;
    min-width: 0;
    background: #F5F7F9;
    border-radius: 8px;
    padding: 4px 12px 16px;
  }

  &__top {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
  }

  &__author {
    font-weight: 500;
    font-size: 12px;
    color: var(--color-accent);
    padding: 5px 0;
  }

  &__date {
    flex-grow: 1;
    text-align: left;
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__text {
    font-size: 12px;
    line-height: 1.27;
    color: var(--color-dark-gray);
    white-space: pre-line;
  }

  &__edit {
    width: 100%;
    box-sizing: border-box;
    padding: 6px 8px;
    border: 1px solid var(--color-purple);
    border-radius: 6px;
    background: var(--color-white);
    font: inherit;
    font-size: 12px;
    line-height: 1.27;
    color: var(--color-dark-gray);
    outline: none;
    resize: vertical;
  }

  &__edit-buttons {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }

  &__attachments {
    margin-top: 10px;
  }
}
</style>
